import { render, staticRenderFns } from "./ReorderUserProfile.vue?vue&type=template&id=b10f578c&"
import script from "./ReorderUserProfile.vue?vue&type=script&lang=ts&"
export * from "./ReorderUserProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports